import {
  MAutocomplete,
  MTextField,
  ResponsiveFormContainer,
} from "@app/components";
import { OPTIONS_YES_NO } from "@app/pages/samples/components/analysisComponents/iodo131/utils/constants";
import { useIsotopos } from "@services/servicesGenericsTables";
import React from "react";
import { useFormContext } from "react-hook-form";

const TiposAnalisisForm = () => {
  const { getValues } = useFormContext();
  const { isotoposList } = useIsotopos();

  return (
    <>
      <ResponsiveFormContainer columns={4}>
        <MAutocomplete
          key={JSON.stringify(getValues("isotope_code"))}
          name="isotope_code"
          options={isotoposList}
          label="Isotopo"
          getOptionLabel={(option) => `${option?.codigo}`}
        />
        <MTextField name="cca" label="CCA" placeholder="CCA" fullWidth />
        <MTextField name="cco" label="CCO" placeholder="CCO" fullWidth />
        <MTextField name="cmk" label="CMK" placeholder="CMK" fullWidth />
        <MTextField
          name="codigo"
          label="Codigo"
          placeholder="Codigo"
          fullWidth
          validation={{ required: "El campo código es requerido" }}
        />

        <MTextField name="cpr" label="CPR" placeholder="CPR" fullWidth />
        <MTextField name="cpra" label="CPRA" placeholder="CPRA" fullWidth />
        <MTextField name="cprf" label="CPRF" placeholder="CPRF" fullWidth />
        <MTextField
          name="descripcion"
          label={"Descripción"}
          type="text"
          fullWidth
          validation={{ required: "El campo descripción es requerido" }}
        />
        <MAutocomplete
          name="confirmed_analysis"
          options={OPTIONS_YES_NO}
          label="Análisis Acreditado"
          getOptionLabel={(option) => `${option.label}`}
          validation={{ required: "El campo acreditado es requerido" }}
        />
      </ResponsiveFormContainer>
    </>
  );
};

export default TiposAnalisisForm;
